import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { InvApiService } from 'src/app/API/invapi.service';
import { AppComponent } from 'src/app/app.component';
import { MachineHistoryDialog } from 'src/app/Core/MachineHistory/MachineHistoryDialog';
import { PartsInventoryComponent } from 'src/app/Core/Shared/PartsInventoryComponent/PartsInventoryComponent';

@Component({
  selector: 'SerialNumberDetails',
  templateUrl: './SerialNumberDetails.component.html',
  styleUrls: ['./SerialNumberDetails.component.css']
})
export class SerialNumberDetailsComponent {
 serialNumber: string | null = null;
 equipmentName: string = '';
 equipmentDesc: string = '';
 barCode: string = '';
 categoryName: string = '';
 divisionName: string = '';
 equipmentType: string = '';
 machineHistoryDialogRef: MatDialogRef<MachineHistoryDialog>;
 equipmentId: number;
 divisionId: number;
 @Input() headerTextOther = "Other Event / Repair";
 @Input() AddUrl = "/WaterProcess/Repairs/RepairDetail";
 partInventoryDetails = 'Inventory/InventoryDetail';
 dmIncidentDetails = '/DialysisMachine/IncidentDetail';
 dmRepairDetails = '/DialysisMachine/DMRepairDetail';
 dmFilterDetails = '/DialysisMachine/FilterDetail';
 dmHoursDetails = 'DialysisMachine/DMHoursUpdateDetail';
 waterProcessDailyDetails = "/WaterProcess/Daily/DEWPDailyDetail";
 WPRepairDetails = "/WaterProcess/Repairs/RepairDetail";
selectedCategory: number | null = null;
CategoryList: any[] = []; selectedInventoryType: string = 'EQUIPMENT';

 constructor(private route: ActivatedRoute,private invapi: InvApiService, public dialog: MatDialog, private router: Router) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.serialNumber = params.get('id'); 
      const serialNumber = { str: this.serialNumber };

       this.invapi.GetEquipmentDetailsBySerialNumber(serialNumber).subscribe(
            success => {
              if (success) {
                this.equipmentName = success.equipmentCode;
                this.equipmentDesc = success.equipmentDesc;
                this.barCode = success.barCode;
                this.categoryName = success.categoryName;
                this.divisionName = success.divisionName;
                this.equipmentId = success.equipementId;
                this.equipmentType =
                    success.equipmentType === 'EQUIPMENT'
                      ? 'Equipment'
                      : success.equipmentType === 'PARTS'
                        ? 'Part'
                        : success.equipmentType;
                this.divisionId = success.divisionId;
              }
            },
            error => {
              if (error.error && error.error.returnMessage){
                AppComponent.addAlert(error.error.returnMessage.toString(), 'error');
                if( error.error.returnMessage.toString().includes('No equipment found for the given serial number.')) {
                  this.equipmentName = this.serialNumber;
                    this.fillCategories();

                }
              }
              else
                AppComponent.addAlert(error.message, 'error');
      
              AppComponent.HideLoader();
            });
    });
  }

    fillCategories() {
      this.invapi.FillCategoryList().subscribe(list => {
        this.CategoryList = list.filter((c: any) => c.text !== 'Select');
        if (this.CategoryList.length > 0) {
          this.selectedCategory = this.CategoryList[0].value;
        }
      });
    } 

   openHistory(EquipId) {
  
      AppComponent.ShowLoader();
  
      const inventory = {
        Id: this.equipmentId
      };
  
      this.invapi.GetInventoryByID(inventory).subscribe(
        success => {
          if (success) {
            this.machineHistoryDialogRef = this.dialog.open(MachineHistoryDialog, {
              disableClose: true,
              position: { right: '0', top: '0' },
              height: '100%',
              width: '70%',
              maxHeight: '100vh'
            });
  
            this.machineHistoryDialogRef.componentInstance.EquipId = EquipId;
            this.machineHistoryDialogRef.componentInstance.SrNo = success.serialnumber;
            this.machineHistoryDialogRef.componentInstance.MachineName = success.equipmentcode;
            this.machineHistoryDialogRef.componentInstance.InServiceDate = success.inservicedate;
            this.machineHistoryDialogRef.componentInstance.detailsType = 'Dialysis Machines';
        
            this.machineHistoryDialogRef.afterClosed().subscribe(result => {
              this.machineHistoryDialogRef = null;
            });
  
          }
          AppComponent.HideLoader();
        },
        error => {
          if (error.error && error.error.returnMessage)
            AppComponent.addAlert(error.error.returnMessage.toString(), 'error');
          else
            AppComponent.addAlert(error.message, 'error');
  
          AppComponent.HideLoader();
        }
      );
  
  }
 
  RouteClick(value) {
    this.router.navigate([value]);
  } 
 
  openPartDetails() {
     this.router.navigate([this.partInventoryDetails], { queryParams: { equipmentId: this.equipmentName, categoryId: this.selectedCategory, inventoryType: this.selectedInventoryType } });
  }

  openPartInfo() {
     this.router.navigate([this.partInventoryDetails], { queryParams: { id: this.equipmentId} });
  }

  openDMIncident() {
    this.router.navigate([this.dmIncidentDetails], {
      queryParams: { 
        divisionId: this.divisionId, 
        equipmentId: this.equipmentId 
      }
    });
  }

  openRepairDetails() {
     this.router.navigate([this.dmRepairDetails], {
      queryParams: { 
        divisionId: this.divisionId, 
        equipmentId: this.equipmentId 
      }
    });
  }

  openFilterDetails() {
     this.router.navigate([this.dmFilterDetails], {
      queryParams: { 
        divisionId: this.divisionId, 
        equipmentId: this.equipmentId 
      }
    });
  }

  openDMHours() {
     this.router.navigate([this.dmHoursDetails], {
      queryParams: { 
        divisionId: this.divisionId, 
        equipmentId: this.equipmentId 
      }
    });
  }
 

  openWPDailyDetails() {
     this.router.navigate([this.waterProcessDailyDetails], {
      queryParams: { 
        divisionId: this.divisionId, 
      }
    });
  }

  openWPRepairDetails() {
     this.router.navigate([this.WPRepairDetails], {
      queryParams: { 
        divisionId: this.divisionId, 
        equipmentId: this.equipmentId 
      }
    });
  }

  openUpdateInventory() {
     const dialogRef =  this.dialog.open(PartsInventoryComponent, {
        disableClose: true,
        position: { right: '0', top: '0' },
        height: '100%',
        width:  '120%',
        maxWidth:  '180vh' ,
        data: { equipementid: this.equipmentId, equipmentcode : this.equipmentName,
                equipmentDesc: this.equipmentDesc, isDialogFromPartsComponent: true }
      });
  }
}
